import api from '@/lib/axios';
import type {
  DeveloperWebLoginRequest,
  DeveloperPhoneLoginRequest,
  SendVerificationCodeRequest,
  DeveloperRegisterRequest,
  ResetPasswordRequest,
  UpdatePasswordRequest,
  UpdateProfileRequest,
  UpdateNameRequest,
  DeveloperWebLoginResponse,
  SendVerificationCodeResponse,
} from '@/types/auth';

/**
 * 开发者 Web 控制台登录（邮箱 + 密码）
 * POST /auth/developer/web/login
 */
export const developerWebLogin = (
  data: DeveloperWebLoginRequest  // ✅ 添加 data: 前缀
): Promise<DeveloperWebLoginResponse> => {
  return api.post('/auth/developer/web/login', data);
};

/**
 * 开发者 Web 控制台登录（手机 + 密码）
 * POST /auth/developer/web/login
 */
export const developerPhoneLogin = (
  data: DeveloperPhoneLoginRequest  // ✅ 添加 data: 前缀
): Promise<DeveloperWebLoginResponse> => {
  return api.post('/auth/developer/web/login', data);
};

/**
 * 开发者 App SDK 登录（动态签名）
 * POST /auth/developer/login
 */
export const developerAppLogin = (
  data: Record<string, unknown>  // ✅ 添加 data: 前缀
): Promise<DeveloperWebLoginResponse> => {
  return api.post('/auth/developer/login', data);
};

/**
 * 发送验证码（支持邮箱/短信）
 * POST /developer/send-code
 */
export const sendVerificationCode = (
  data: SendVerificationCodeRequest  // ✅ 添加 data: 前缀
): Promise<SendVerificationCodeResponse> => {
  return api.post('/developer/send-code', data);
};

/**
 * 发送重置密码验证码（支持邮箱/短信）
 * POST /developer/send-reset-code
 */
export const sendResetPasswordCode = (
  data: SendVerificationCodeRequest  // ✅ 添加 data: 前缀
): Promise<SendVerificationCodeResponse> => {
  return api.post('/developer/send-reset-code', data);
};

/**
 * 开发者注册（支持邮箱/手机 + 验证码）
 * POST /developer/register
 */
export const registerDeveloper = (
  data: DeveloperRegisterRequest
): Promise<void> => {
  return api.post('/developer/register', data);
};

/**
 * 重置密码（支持邮箱/手机 + 验证码）
 * POST /developer/reset-password
 */
export const resetPassword = (
  data: ResetPasswordRequest  // ✅ 添加 data: 前缀
): Promise<void> => {
  return api.post('/developer/reset-password', data);
};

/**
 * 开发者登出
 * POST /developer/logout
 */
export const logoutDeveloper = (): Promise<void> => {
  return api.post('/developer/logout');
};

/**
 * 获取当前开发者信息（需登录）
 * GET /developer/profile
 */
export const getCurrentDeveloper = (): Promise<unknown> => {
  return api.get('/developer/profile');
};

/**
 * 更新个人信息（需登录）
 * PUT /developer/profile
 */
export const updateProfile = (
  data: UpdateProfileRequest  // ✅ 添加 data: 前缀
): Promise<void> => {
  return api.put('/developer/profile', data);
};

/**
 * 只更新用户名（需登录）
 * PATCH /developer/profile/name
 */
export const updateProfileName = (
  data: UpdateNameRequest  // ✅ 添加 data: 前缀
): Promise<void> => {
  return api.patch('/developer/profile/name', data);
};

/**
 * 修改密码（需登录，验证旧密码）
 * PUT /developer/password
 */
export const updatePassword = (
  data: UpdatePasswordRequest  // ✅ 添加 data: 前缀
): Promise<void> => {
  return api.put('/developer/password', data);
};